'use es6';

import UISection from 'UIComponents/section/UISection';
import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import UITile from 'UIComponents/tile/UITile';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SkeletonCard = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCard",
  componentId: "sc-13h19ua-0"
})(["max-width:100%;display:flex;flex-direction:column;"]);
const SkeletonCardFlexRowBetween = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCardFlexRowBetween",
  componentId: "sc-13h19ua-1"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:px 10px;"]);
const SkeletonCardContainer = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCardContainer",
  componentId: "sc-13h19ua-2"
})(["max-width:100%;margin:10px 15px;display:flex;flex-direction:column;"]);
const SkeletonCardTitleCell = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCardTitleCell",
  componentId: "sc-13h19ua-3"
})(["background-color:", ";background-size:1200;height:20px;width:40%;padding:10px;border-radius:5px;margin:10px;"], KOALA);
const SkeletonCardSmallCell = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCardSmallCell",
  componentId: "sc-13h19ua-4"
})(["background-color:", ";background-size:1200;height:20px;width:15%;padding:10px;border-radius:5px;margin:10px;"], KOALA);
const SkeletonCardAttrCell = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCardAttrCell",
  componentId: "sc-13h19ua-5"
})(["background-color:", ";background-size:1200;height:20px;width:70%;padding:10px;border-radius:5px;margin:10px;"], KOALA);
const SkeletonCardFlexRow = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCardFlexRow",
  componentId: "sc-13h19ua-6"
})(["max-width:100%;display:flex;flex-direction:row;"]);
const SkeletonCardMediumCell = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonCardMediumCell",
  componentId: "sc-13h19ua-7"
})(["background-color:", ";background-size:1200;height:20px;width:40%;padding:10px;border-radius:5px;margin:10px;"], KOALA);
const SecondaryAttrValue = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SecondaryAttrValue",
  componentId: "sc-13h19ua-8"
})(["background-color:", ";background-size:1200;height:20px;width:20%;padding:10px;border-radius:5px;margin:10px;"], KOALA);
const SkeletonHighlightCardPicture = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonHighlightCardPicture",
  componentId: "sc-13h19ua-9"
})(["height:70px;width:70px;background-color:", ";border-radius:50%;"], KOALA);
const SkeletonHighlightAttrContainer = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonHighlightAttrContainer",
  componentId: "sc-13h19ua-10"
})(["display:flex;flex-direction:column;width:70%;"]);
const SkeletonActivityButton = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonActivityButton",
  componentId: "sc-13h19ua-11"
})(["height:40px;width:40px;background-color:", ";border-radius:50%;"], KOALA);
const SkeletonPropertiesCardTitleCell = styled.div.withConfig({
  displayName: "UniversalSidebarLoading__SkeletonPropertiesCardTitleCell",
  componentId: "sc-13h19ua-12"
})(["background-color:", ";background-size:1200;height:10px;width:30%;border-radius:5px;margin:10px;"], KOALA);
const renderSkeletonActivityButtons = () => {
  const n = 6;
  return [...Array(n)].map((e, i) => /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx(SkeletonActivityButton, {})
  }, i));
};
const renderSecondaryAttrCell = () => {
  return /*#__PURE__*/_jsxs(SkeletonCardFlexRow, {
    children: [/*#__PURE__*/_jsx(SkeletonCardMediumCell, {}), " ", /*#__PURE__*/_jsx(SecondaryAttrValue, {})]
  });
};
const renderChickletSkeleton = () => {
  return /*#__PURE__*/_jsxs(UITile, {
    children: [/*#__PURE__*/_jsx(SkeletonCardAttrCell, {}), renderSecondaryAttrCell()]
  });
};
const renderCardSkeleton = () => {
  return /*#__PURE__*/_jsxs(SkeletonCard, {
    children: [/*#__PURE__*/_jsxs(SkeletonCardFlexRowBetween, {
      children: [/*#__PURE__*/_jsx(SkeletonCardTitleCell, {}), /*#__PURE__*/_jsx(SkeletonCardSmallCell, {})]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    }), /*#__PURE__*/_jsxs(SkeletonCardContainer, {
      children: [renderChickletSkeleton(), renderChickletSkeleton(), /*#__PURE__*/_jsx(SkeletonCardMediumCell, {})]
    })]
  });
};
const renderPropertySkeleton = () => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(SkeletonPropertiesCardTitleCell, {}), /*#__PURE__*/_jsx(SkeletonCardTitleCell, {})]
  });
};
const renderPropertiesSkeleton = () => {
  const n = 6;
  return [...Array(n)].map((e, i) => /*#__PURE__*/_jsx("span", {
    children: renderPropertySkeleton()
  }, i));
};
const renderPropertiesCardSkeleton = () => {
  return /*#__PURE__*/_jsxs(SkeletonCard, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex-row justify-between",
      children: /*#__PURE__*/_jsx(SkeletonCardTitleCell, {})
    }), /*#__PURE__*/_jsx(SkeletonCardContainer, {
      children: renderPropertiesSkeleton()
    })]
  });
};
const renderHighlightCard = () => {
  return /*#__PURE__*/_jsxs(SkeletonCard, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex-row justify-between",
      children: [/*#__PURE__*/_jsx(SkeletonCardTitleCell, {}), /*#__PURE__*/_jsx(SkeletonCardSmallCell, {})]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "extra-small"
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex-row p-all-3",
      children: [/*#__PURE__*/_jsx(SkeletonHighlightCardPicture, {}), /*#__PURE__*/_jsxs(SkeletonHighlightAttrContainer, {
        children: [/*#__PURE__*/_jsx(SkeletonCardAttrCell, {}), /*#__PURE__*/_jsx(SkeletonCardMediumCell, {})]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "flex-row justify-around p-x-5 p-y-2",
      children: renderSkeletonActivityButtons()
    })]
  });
};
const UniversalSidebarLoading = ({
  cardLocation
}) => {
  const renderRightSidebarLoading = () => {
    return /*#__PURE__*/_jsxs("div", {
      children: [renderCardSkeleton(), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      }), renderCardSkeleton(), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      }), renderCardSkeleton()]
    });
  };
  const renderSidebarLoading = () => {
    return /*#__PURE__*/_jsxs("div", {
      children: [renderHighlightCard(), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      }), renderPropertiesCardSkeleton(), /*#__PURE__*/_jsx(HR, {
        distance: "extra-small"
      }), renderCardSkeleton()]
    });
  };
  return /*#__PURE__*/_jsx(UISection, {
    children: cardLocation === 'CRM_RECORD_RIGHT' ? renderRightSidebarLoading() : renderSidebarLoading()
  });
};
export default UniversalSidebarLoading;